import _ from 'underscore';

export const getFullyShownContentsCount = (width, contentWidth) => {
  if (!_.isNumber(width) || width <= 0 || !_.isNumber(contentWidth) || contentWidth <= 0) {
    return 0;
  }
  return Math.floor(width / contentWidth);
};
